import { render } from "./Accueil.vue?vue&type=template&id=950d635a&ts=true"
import script from "./Accueil.vue?vue&type=script&lang=ts"
export * from "./Accueil.vue?vue&type=script&lang=ts"

import "./Accueil.vue?vue&type=style&index=0&id=950d635a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__